import { render } from "./Loading.vue?vue&type=template&id=0ac479df"
const script = {}

import exportComponent from "/var/www/html/congreso_online/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__